// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verticaltab-container[data-v-262b9fe3]{width:100%}.verticaltab-list[data-v-262b9fe3]{display:flex;flex-direction:column;gap:12px}.verticaltab-item-wrap[data-v-262b9fe3]{padding:8px 0}.verticaltab-item[data-v-262b9fe3]{font-size:18px;line-height:1.5;color:var(--black400);font-weight:600}.verticaltab-item.active[data-v-262b9fe3]{color:var(--black900)}", ""]);
// Exports
module.exports = exports;
